type Props = {
  width?: number;
  height?: number;
};

export function Logo({ width, height }: Props) {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 219.04 55.6"
      width={width}
      height={height}
    >
      <path
        d="m43,18.7l2.8-1.1c-.7-1.2-1.5-2.3-2.4-3.4l5-5-2.1-2.1-5,5c-1-.9-2.2-1.7-3.4-2.4l-1.1,2.8c2.5,1.5,4.7,3.7,6.2,6.2Z"
        fill="currentcolor"
        strokeWidth="0"
      />
      <path
        d="m45.8,37.9l-2.8-1.1c-1.5,2.6-3.7,4.7-6.2,6.2l1.1,2.8c1.2-.7,2.3-1.5,3.4-2.4l5,5,2.1-2.1-5-5c.9-1,1.7-2.2,2.4-3.4Z"
        fill="currentcolor"
        strokeWidth="0"
      />
      <path
        d="m48.4,26.2c-.1-1.4-.4-2.8-.7-4.1l-2.8,1.1c.4,1.4.6,2.9.6,4.4s-.2,3-.6,4.4l2.8,1.2c.4-1.3.6-2.7.7-4.1h7.1v-3c0,.1-7.1.1-7.1.1Z"
        fill="currentcolor"
        strokeWidth="0"
      />
      <path
        d="m17.4,27.8c0-8.5,6.4-15.6,14.7-17.2l1.1-2.8c-1.3-.4-2.7-.6-4.1-.7V0h-3v7.1h0c-4.6.3-8.8,2.1-12.1,5h0l-5-5-1.9,2.1,5,5c-2.8,3.3-4.7,7.5-5,12.1H0v3h7.1c.3,4.6,2.1,8.8,5,12.1l-5,5,2.1,2.1,5-5c3.3,2.8,7.5,4.7,12.1,5h0v7.1h3v-7.1c1.4-.1,2.8-.4,4.1-.7l-1.1-2.8c-8.4-1.7-14.9-8.8-14.9-17.2h0Z"
        fill="currentcolor"
        strokeWidth="0"
      />
      <path
        d="m66.3,29.1c0,.7.1,1.4.2,2s.3,1.2.4,1.7c.6,1.6,1.6,2.8,2.9,3.7,1.3.8,2.8,1.2,4.5,1.2,1.3,0,2.6-.2,3.9-.6,1.2-.4,2.6-.9,3.9-1.7l1.8,3.1c-1.7,1.1-3.3,2-5,2.5-1.7.6-3.4.8-5.2.8-1.7,0-3.3-.3-4.8-.8-1.5-.6-2.7-1.4-3.8-2.5s-1.9-2.5-2.5-4.2-.9-3.6-.9-5.9c0-1.8.2-3.5.8-5.1.5-1.6,1.3-3,2.3-4.2s2.2-2.1,3.7-2.8,3.2-1,5.2-1,3.5.3,4.8.9c1.3.6,2.3,1.3,3.1,2.3s1.4,2,1.8,3.3.7,2.5.9,3.7c.1.6.1,1.2.2,1.9s0,1.2,0,1.9l-18.2-.2h0Zm7.1-10.1c-1.1,0-2,.1-2.8.5-.8.3-1.5.7-2,1.3s-1,1.2-1.3,2.1-.6,1.7-.8,2.7h13.1c-.1-.9-.2-1.8-.4-2.6-.2-.8-.6-1.5-1.1-2.1s-1.1-1-1.9-1.4c-.7-.3-1.6-.5-2.8-.5h0Z"
        fill="currentcolor"
        strokeWidth="0"
      />
      <path
        d="m106,22.6c-.7-1.2-1.6-2.1-2.6-2.7s-2.3-.9-3.6-.9c-1.1,0-2.1.2-3,.7s-1.7,1.1-2.4,1.9-1.2,1.8-1.6,3-.6,2.5-.6,3.9.2,2.7.6,3.8.9,2.1,1.6,2.9,1.5,1.4,2.4,1.9c.9.4,1.9.7,3,.7,1.6,0,2.9-.4,4.1-1.1,1.2-.8,2.1-1.9,2.8-3.3l3.8,1.9c-.5,1-1.1,2-1.8,2.8s-1.5,1.5-2.4,2.1-1.9,1-3,1.3-2.2.5-3.4.5c-1.8,0-3.4-.3-4.9-1s-2.8-1.6-3.9-2.8-1.9-2.6-2.5-4.2c-.6-1.6-.9-3.4-.9-5.4s.3-3.8.9-5.4,1.5-3.1,2.6-4.2c1.1-1.2,2.4-2.1,3.9-2.8s3.1-1,4.8-1c1.6,0,3.1.3,4.5.8,1.4.5,2.7,1.4,3.8,2.5h2.6v4.2l-4.8-.1h0Z"
        fill="currentcolor"
        strokeWidth="0"
      />
      <path
        d="m112.8,3.2h8.2v33.8h3.8v4.2h-12v-4.2h3.7V7.4h-3.7V3.2Z"
        fill="currentcolor"
        strokeWidth="0"
      />
      <path
        d="m128.6,15.9h8.2v21.1h3.8v4.2h-12v-4.2h3.6v-16.9h-3.7l.1-4.2h0Zm2.8-9c0-.4.1-.8.3-1.2s.4-.7.7-1,.6-.5,1-.7.8-.3,1.2-.3.8.1,1.2.3.7.4,1,.7.5.6.7,1,.3.8.3,1.2-.1.9-.3,1.2c-.2.3-.4.7-.7,1s-.6.5-1,.7-.8.3-1.2.3-.9-.1-1.2-.3-.7-.4-1-.7-.5-.6-.7-1-.3-.7-.3-1.2Z"
        fill="currentcolor"
        strokeWidth="0"
      />
      <path
        d="m142.8,15.9h8.1v2.1c1.1-.8,2.2-1.5,3.5-2s2.6-.7,3.9-.7c1.7,0,3.2.3,4.6.9,1.4.6,2.6,1.5,3.6,2.6s1.8,2.5,2.3,4,.8,3.3.8,5.2c0,2-.3,3.9-.9,5.6-.6,1.7-1.5,3.1-2.6,4.3s-2.4,2.1-3.9,2.8-3.2,1-5,1c-1.3,0-2.4-.1-3.4-.4-1-.3-2-.6-2.9-1v8.2h4v4.2h-12v-4.2h3.5v-28.4h-3.5l-.1-4.2h0Zm14.3,3.4c-1.2,0-2.3.2-3.4.7-1.1.5-2,1.1-2.8,2v13.7c.5.5,1.3,1,2.3,1.5s2.2.7,3.8.7c1,0,2-.2,3-.6,1-.4,1.8-1,2.5-1.8s1.3-1.8,1.8-3c.4-1.2.7-2.6.7-4.1,0-1.4-.2-2.7-.6-3.8-.4-1.1-1-2-1.7-2.8s-1.5-1.4-2.5-1.8c-1-.5-2-.7-3.1-.7h0Z"
        fill="currentcolor"
        strokeWidth="0"
      />
      <path
        d="m187.4,20.9c-.3-.5-.7-.9-1.2-1.2s-1.1-.5-1.7-.7c-.6-.1-1.2-.2-1.8-.2s-1.2.1-1.8.2-1,.4-1.4.6c-.4.3-.7.6-.9,1s-.3.8-.3,1.3c0,.9.3,1.5.8,2s1.4,1,2.6,1.4l4.9,1.7c2.1.7,3.6,1.6,4.6,2.9,1,1.2,1.4,2.7,1.4,4.3,0,1.1-.2,2.2-.7,3.1-.4.9-1.1,1.7-1.9,2.4-.8.7-1.8,1.2-3,1.5s-2.4.6-3.9.6c-2,0-3.6-.3-4.8-1-1.2-.6-2.2-1.5-2.9-2.5h-2.5v-4.2h5.1c0,.7.1,1.3.4,1.8.3.5.7.9,1.2,1.2s1.1.5,1.7.7c.6.2,1.3.2,1.9.2s1.2-.1,1.8-.2c.6-.2,1.1-.4,1.6-.7.4-.3.8-.7,1.1-1.1.3-.4.4-.9.4-1.4,0-.8-.3-1.5-.8-2.1s-1.4-1.1-2.7-1.5l-4.8-1.8c-2-.7-3.4-1.6-4.4-2.7s-1.4-2.4-1.4-4.1c0-1.1.2-2.1.6-3,.4-.9,1-1.7,1.7-2.4s1.7-1.2,2.8-1.5c1.1-.4,2.3-.6,3.7-.6,1.8,0,3.3.2,4.5.8,1.2.5,2.3,1.4,3.3,2.6h2.4v4.2h-5c-.1-.5-.2-1.1-.6-1.6h0Z"
        fill="currentcolor"
        strokeWidth="0"
      />
      <path
        d="m200.8,29.1c0,.7.1,1.4.2,2,.1.6.3,1.2.4,1.7.6,1.6,1.6,2.8,2.9,3.7,1.3.8,2.8,1.2,4.5,1.2,1.3,0,2.6-.2,3.9-.6,1.2-.4,2.6-.9,3.9-1.7l1.8,3.1c-1.7,1.1-3.3,2-5,2.5-1.7.6-3.4.8-5.2.8-1.7,0-3.3-.3-4.8-.8-1.5-.6-2.7-1.4-3.8-2.5s-1.9-2.5-2.5-4.2-.9-3.6-.9-5.9c0-1.8.2-3.5.8-5.1.5-1.6,1.3-3,2.3-4.2s2.2-2.1,3.7-2.8,3.2-1,5.2-1,3.5.3,4.8.9c1.3.6,2.3,1.3,3.1,2.3s1.4,2,1.8,3.3.7,2.5.9,3.7c.1.6.1,1.2.2,1.9s0,1.2,0,1.9l-18.2-.2h0Zm7.1-10.1c-1.1,0-2,.1-2.8.5-.8.3-1.5.7-2,1.3s-1,1.2-1.3,2.1-.6,1.7-.8,2.7h13.1c-.1-.9-.2-1.8-.4-2.6-.2-.8-.6-1.5-1.1-2.1s-1.1-1-1.9-1.4c-.7-.3-1.6-.5-2.8-.5h0Z"
        fill="currentcolor"
        strokeWidth="0"
      />
    </svg>
  );
}
